exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".choose-card{margin-bottom:.5rem}.add-card{margin:0 0 1.2rem}p.paragraph{margin-top:0;margin-bottom:1rem}.el-dialog__body{padding-top:.5rem}.standout{font-weight:600;color:#444;margin-left:22px}.standout-accent{color:#f67e22}.top-column{background:#ebebec;width:240px;padding:10px;margin-top:35px;border-radius:11px}.top-title{font-size:17px;padding-bottom:4px}.reset .el-form-item__content{margin-left:0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-23aad9ae","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?indentedSyntax!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/user/blocks/AcceptEstimateDialog.vue
// module id = 491
// module chunks = 0